import PageShell from "@/components/PageShell";
import { Comision } from "@/components/landing/Comision";

export default function ComisionPage() {
  return (
    <PageShell crumbs={[{ label: "Comisión Directiva" }]}>
      <Comision />
    </PageShell>
  );
}
